import * as React from 'react';
import CommonLayout from './common-layout';

const AllPostsLayout = ({ children, avatar }) => {
   return (
      <CommonLayout avatar={avatar}>
         <section className="height-wrapper">{children}</section>
      </CommonLayout>
   );
};

export default AllPostsLayout;
